var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
import { useCSSTransition } from "@react-md/transition";
import { useStatesConfigContext } from "../StatesConfig";
export function Ripple(_a) {
  var className = _a.className,
    propClassNames = _a.classNames,
    propTimeout = _a.timeout,
    ripple = _a.ripple,
    entered = _a.entered,
    exited = _a.exited;
  var exiting = ripple.exiting,
    style = ripple.style;
  var timeout = propTimeout;
  var classNames = propClassNames;
  var context = useStatesConfigContext();
  if (typeof timeout === "undefined" || typeof classNames === "undefined") {
    if (typeof timeout === "undefined") {
      timeout = context.rippleTimeout;
    }
    if (typeof classNames === "undefined") {
      classNames = context.rippleClassNames;
    }
  }
  var _b = useCSSTransition({
      appear: true,
      transitionIn: !exiting,
      timeout: timeout,
      className: cn("rmd-ripple", className),
      classNames: classNames,
      onEntered: function onEntered() {
        entered(ripple);
      },
      onExited: function onExited() {
        exited(ripple);
      }
    }),
    elementProps = _b.elementProps,
    rendered = _b.rendered;
  if (!rendered) {
    return null;
  }
  return _jsx("span", __assign({}, elementProps, {
    style: style
  }));
}